import { HarloweSupport } from "@harlowe/core";
import { TealCompReferral, TealCompReferralHeader } from "../../models/teal-comp-referral";
import { Diary, Note, ReceivedEmail, SentEmail, User } from "@harlowe/core"


export namespace Referrals 
{

    export class UserLoggedIn
    {
        static readonly type = "[Referral Login Action] Successful Login";
        constructor(public payload: { user: User }) {}
    }

    export class InitialReferralsLoaded
    {
        static readonly type = "[Referrals Action] Referrals Loaded";
    }

    export class NewReferralReceived
    {
        static readonly type = "[Referral Service] New Referral Received";
        constructor(public payload: { referral: TealCompReferralHeader }) {}
    }

    export class ReferralSelected
    {
        static readonly type = "[Referral List] Referral Selected";
        constructor(public payload: { referral: TealCompReferralHeader}) {}
    }

    export class ReferralUpdated
    {
        static readonly type = "[Referral Editor] Referral Updated";
        constructor(public payload: { referral: TealCompReferralHeader }) {}
    }

    export class ReferralClosed
    {
        static readonly type="[ReferralService] Referral Closed";
        constructor(public payload: {referral: TealCompReferralHeader}) {}
    }
    
    export class ReferralUpdateComplete
    {
        static readonly type = "[Referral Editor] Referral Update Complete";
    }

    export class AuthorizationCreatedForReferral
    {
        static readonly type = "[Referral List] Authorization Created For Referral";
        constructor(public payload: {referral: TealCompReferralHeader}) {}
    }

    export class ReferralSubmittedForAuthorization
    {
        static readonly type = "[Referral List] Referral Submitted For Authorization";
        constructor(public payload: {referral: TealCompReferral}) {}
    }

    export class ReferralSubmittedForReAuthorization
    {
        static readonly type = "[Referral List] Referral Submitted For ReAuthorization";
        constructor(public payload: {referral: TealCompReferral}) {}
    }

    export class ReferralAuthSubmittedForCreation
    {
        static readonly type="[Referral List] Referral Auth Submitted For Creation";
        constructor(public payload: {referral: TealCompReferral}) {}
    }

    export class ReferralAuthCreated
    {
        static readonly type="[Referral List] Referral Auth Created";
        constructor(public payload: {referral: TealCompReferral}) {}
    }

    export class ReferralAuthorizationStatus
    {
        static readonly type = "[Referral List] Referral Authorization Status Received";
        constructor(public payload: {referral: TealCompReferralHeader}) {}
    }

    export class DiaryUpdated
    {
        static readonly type="[Encounter State] Diary Updated";
        constructor(public payload: {encounterId: number, diary: Diary}){}
    }

    export class DiaryAdded
    {
        static readonly type="[Encounter State] Diary Added";
        constructor(public payload: {encounterId: number, diary: Diary}){}
    }

    export class NoteUpdated
    {
        static readonly type="[Encounter State] Note Updated";
        constructor(public payload: {encounterId: number, note: Note}){}
    }

    export class NoteAdded
    {
        static readonly type="[Encounter State] Note Added";
        constructor(public payload: {encounterId: number, note: Note}){}
    }

    export class NoteDeleted
    {
        static readonly type="[Encounter State] Note Deleted";
        constructor(public payload: {encounterId: number, noteId: number}){}
    }

    export class EncounterStateEncounterEmailSent
    {
        static readonly type="[Encounter State] Email Sent";
        constructor(public payload:{encounterId: number, email: SentEmail}){};
    }
    export class EncounterStateEncounterEmailReceived
    {
        static readonly type="[Encounter State] Email Received";
        constructor(public payload:{encounterId: number, email: ReceivedEmail}){};
    }

    export class EncounterStateEncounterEmailUpdated
    {
        static readonly type="[Encounter State] Email Updated";
        constructor(public payload:{email: SentEmail}){};
    }

    export class EncounterStateAttachmentAdded
    {
        static readonly type="[Encounter State] Attachment Added";
        constructor(public payload:{encounterId: number, file: HarloweSupport.File}){};
    }

    export class EncounterStateAttachmentsAdded
    {
        static readonly type="[Encounter State] Attachments Added";
        constructor(public payload:{encounterId: number, files: HarloweSupport.File[]}){};
    }
    
    export class EncounterStateAttachmentDeleted
    {
        static readonly type="[Encounter State] Attachment Deleted";
        constructor(public payload:{encounterId: number, file: HarloweSupport.File}){};
    }

    export class ReferralServiceReferralEmailSent
    {
        static readonly type="[Referral Service] Email Sent";
        constructor(public payload:{referralId: number, email: SentEmail}){};
    }
    
    export class PersistState
    {
        static readonly type="[Referral State] Persist";
    }
    
}